import { Component, Input, OnInit } from '@angular/core';
import { SaleChannel } from '../../lib/model/SaleChannel';
import { Transaction } from '../../lib/model/Transaction';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
  @Input() saleChannel: SaleChannel;
  @Input() transaction: Transaction;
  @Input() currentPage: string;

  constructor() { }

  ngOnInit() { }
}
